export { RequestFile } from "../model/models";
export * from "./defaultApi";
import * as http from "http";
import { DefaultApi } from "./defaultApi";

export class HttpError extends Error {
  constructor(
    public response: http.IncomingMessage,
    public body: any,
    public statusCode?: number
  ) {
    super("HTTP request failed");
    this.name = "HttpError";
  }
}

export const APIS = [DefaultApi];
